import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import "./Translator.css"

export default function Language() {

    const { t, i18n } = useTranslation();
    const changeLanguage = e => i18n.changeLanguage(e.target.value)
    const [toggle, toggleLanguage] = useState(false)

    const languages = () => {
        toggleLanguage(!toggle)
    }
    return (
        <>
            <div onClick={languages} className="material-icons icon--large">
                translate
            </div>
            <div onClick={languages} className="dropdown">
                <span>{t('language')}</span>
                <div className="dropdown-content" style={{ display: toggle ? 'flex' : 'none'}}>
                    <button onClick={(e) => changeLanguage(e)} value='en'>English (US) </button>
                    <button onClick={(e) => changeLanguage(e)} value='fr'>French </button>
                    <button onClick={(e) => changeLanguage(e)} value='de'>German </button>
                    <button onClick={(e) => changeLanguage(e)} value='jp'>Japanese </button>
                    <button onClick={(e) => changeLanguage(e)} value='es'>Spanish </button>
                </div>
            </div>
        </>
    )
}
